import { AxiosResponse } from "axios";
import { Dispatch } from "@reduxjs/toolkit";

import {
  setUserId,
  setUserType,
  setUserPermissions,
} from "./verifyEmail.slice";
import {
  getApiCallForLogin,
  postApiCallForLogin,
} from "../../../common/constants/api";
import { SupportFormValues } from "./types";
import { setLoading } from "../../../redux/global.slice";
import { EndPoint, Module } from "../../../common/constants";
import { getMyProfileData } from "../../my-profile/services/action";
import { apiSuccessCode } from "../../../common/constants/axios.instance";
import { checkInternetAndShowAlert, showAlert } from "../../../common/utils";
import {
  AnalyticsEvents,
  capturePosthogEvent,
} from "../../../common/utils/analytics";
import { RootState } from "../../../redux/store";

export const verifyEmail =
  (email: string, callback?: () => void) => (dispatch: Dispatch<any>) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }

    const dataToSend = {
      email,
      deviceId: `${Date.now()}`,
    };

    postApiCallForLogin(
      Module.manufacturer + EndPoint.verifyEmail,
      dataToSend,
      (respData: AxiosResponse<any>) => {
        const { data } = respData;
        if (data?.statusCode === apiSuccessCode.success) {
          dispatch(setUserId(data?.data.userId));
          dispatch(setUserType(data?.data.userType));
          if (data?.data?.permissions) {
            dispatch(setUserPermissions(data?.data.permissions));
          }
          if (callback) callback();
        }
        // dispatch(setLoading(false));
      },
      (error: any) => {
        if (error.statusCode === 400) {
          showAlert(2, error.message);
        }
        capturePosthogEvent(AnalyticsEvents.MANUFACTURER_LOGIN_FAILED, {
          email,
          reason:
            error?.message ??
            error?.code ??
            "manufacturer_email_verification_failed",
        });
        //  showAlert(2, error.message);
        dispatch(setLoading(false));
      },
    );
  };

export const supportEmail =
  (values: SupportFormValues, callback?: () => void) =>
  (dispatch: Dispatch<any>, getState: () => RootState) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }

    dispatch(setLoading(true));

    postApiCallForLogin(
      Module.manufacturer + EndPoint.support,
      values,
      (respData: AxiosResponse<any>) => {
        const { data } = respData;
        if (data?.statusCode === apiSuccessCode.success) {
          if (callback) callback();
        }

        dispatch(setLoading(false));
      },
      (error: any) => {
        dispatch(setLoading(false));
        const uid = getState().verifyEmail.userId;
        capturePosthogEvent(AnalyticsEvents.MANUFACTURER_LOGIN_FAILED, {
          email: values?.email,
          user_id: uid ? uid : "",
          reason: error?.message ?? "wallet_details_failed",
        });
        showAlert(2, error.message);
      },
    );
  };

export const setWalletDetails =
  (values: any, userId?: string | any, callback?: any) =>
  (dispatch: Dispatch<any>) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }

    postApiCallForLogin(
      Module.manufacturer + EndPoint.walletDetails,
      values,
      (respData: AxiosResponse<any>) => {
        const { data } = respData;
        if (data?.statusCode === apiSuccessCode.success) {
          if (callback) {
            dispatch(getMyProfileData(userId, true, callback));
            dispatch(setLoading(false));
          }
        }
      },
      (error: any) => {
        dispatch(setLoading(false));
        showAlert(2, error.message);
      },
    );
  };

export const getDynamicSupportEmail =
  (setSupportDynamicEmail: any) => (dispatch: Dispatch<any>) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }
    dispatch(setLoading(true));
    getApiCallForLogin(
      Module.manufacturer,
      `${EndPoint.dynamicSupportEmail}?type=support`,
      (response: AxiosResponse<any>) => {
        const { statusCode, data } = response.data;

        if (statusCode === apiSuccessCode.success) {
          setSupportDynamicEmail(data.email);
        }
        dispatch(setLoading(false));
      },
      (error: any) => {
        dispatch(setLoading(false));
        showAlert(2, error.message);
      },
    );
  };
